import containerFuild from '../html-snippets/container-fuild.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/fastvaluedeal-card-basic';

const dividerPrimaryHeaderHtml = dividerPrimary({
  show: true,
  maxWidth: 90,
  height: 6,
  align: 'center',
  backgroundColor: '#5B04DE',
});

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 90,
  height: 6,
  align: 'left',
  backgroundColor: '#5B04DE',
});

const featureItemHtml = ({ content, imageSrc, imageShow = true }) => `
<div
  class="fvd-card-basic__feature-item"
  data-attribute="fvd-card-basic__feature-item"
>  <div data-attribute="fvd-card-basic__feature-content" class="fvd-card-basic__feature-content">
    ${content}
  </div>
  <div
    data-show="${imageShow ? 'true' : 'false'}"
    data-attribute="fvd-card-basic__feature-image-wrap"
    class="fvd-card-basic__feature-image-wrap"
    style="display: ${imageShow ? '' : 'none'}"
  >
    <img
      data-attribute="fvd-card-basic__feature-image"
      src="${imageSrc}"
      alt="image"
    />
  </div>
</div>`;

const html = `
<div
  class="fvd-card-basic-content container"
  data-attribute="fvd-card-basic-content"
  data-grid-ratio="2fr-1fr"
  data-image-position="right"
  data-image-show="true"
  data-features-show="true"
>
  <div data-show="false" style="display: none" data-attribute="fvd-card-basic__section-title-wrap" class="fvd-card-basic__section-title-wrap" >
    <div
      data-attribute="fvd-card-basic__section-title"
      class="fvd-card-basic__section-title"
    >
      <h2 style="text-align: center"><strong>Never Overpay For TV Again</strong></h2>
    </div>
    ${dividerPrimaryHeaderHtml}
  </div>
  <div class="fvd-card-basic__grid" data-attribute="fvd-card-basic__grid">
    <div class="fvd-card-basic__left" data-attribute="fvd-card-basic__left">
      <div data-attribute="fvd-card-basic__context-title" class="fvd-card-basic__context-title">
        <h2><strong>Cutting-Edge Technology For Smarter Television</strong></h2>
      </div>
      ${dividerPrimaryHtml}
      <div data-attribute="fvd-card-basic__context-text" class="fvd-card-basic__context-text">
        <p>
          <span style="color:hsl( 0, 1%, 46% );">
            If you would like to revamp your home entertainment experience, look no further than WaveMax. This compact yet powerful antenna can broadcast hundreds of channel signals from as far as 120 miles away, providing you with endless viewing fun. The secret – continuous wide-range scanning of all available frequencies, broadcasting only the highest quality options to your television set.
          </span>
        </p>
      </div>
      <div
        data-show="true"
        data-attribute="fvd-card-basic__features"
        class="fvd-card-basic__features"
        data-background-color="#0130E2"
        data-text-color="#FFFFFF"
        style="--feature-bg: #0130E2; --feature-text: #FFFFFF;"
      >
        ${featureItemHtml({
          content:
            '<p style="text-align:center;"><strong>AUTOMATICALLY SCANS</strong><br><strong>FOR CHANNELS</strong></p>',
          imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211fa5e0c4be906ce2714c.jpg',
        })}
        ${featureItemHtml({
          content:
            '<p style="text-align:center;"><strong>WIDE BOARDCAST</strong><br><strong>CORVERAGE RANGE</strong></p>',
          imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211fb3fcc0c411b91cb89c.jpg',
        })}
      </div>
    </div>
    <div class="fvd-card-basic__right" data-attribute="fvd-card-basic__right">
      <div
        data-show="true"
        data-attribute="fvd-card-basic__side-image"
        class="fvd-card-basic__side-image"
      >
        <img
          data-attribute="fvd-card-basic__side-image-img"
          src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a211fbe5ac9f5fb0263af3e.jpg"
          alt="image"
        />
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#F8F8F8',
});
